<template>
  <article :aria-label="title" :class="`other-experiences ${reversed ? 'reverse' : ''}`" :key="index">
    <img :src="image" :alt="alt">
    <div class="text">
      <h2>{{ title }}</h2>
      <p v-html="description"></p>
      <a v-if="isExternalLink" :href="link" class="blue-button" target="_blank" rel="noopener noreferrer">
      {{ linkText }}
    </a>
    <router-link v-else :to="link" class="blue-button">
      {{ linkText }}
    </router-link>
    </div>
  </article>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator';

  @Component({
    props: {
      index: {
        type: Number,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      description: {
        type: String,
        required: true,
      },
      link: {
        type: String,
        required: true,
      },
      link_text: {
        type: String,
        default: '',
        required: true,
      },
      image: {
        type: String,
        required: true,
      },
      imageAlt: {
        type: String,
        required: true,
      },
      reversed: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isExternalLink() {
        return this.link.startsWith('http://') || this.link.startsWith('https://');
      },
      linkText() {
        return this.link_text.length ? this.link_text : 'Learn More';
      },
    },
  })
class FeaturedExperiences extends Vue {
  }
export default FeaturedExperiences;
</script>
<style lang="scss" scoped>
.other-experiences {
  height: auto;
  display: block;
  margin: 100px auto 0;
  padding: 0 var(--spacing-l);

  img {
    box-shadow: 0px 12px 20px 0px #0E1F351F;
    border-radius: var(--spacing-xs);
    height: 484px;
    object-fit: cover;
    width: 100%;
  }

  .text {
    flex-grow: 1;
    gap: var(--spacing-l);
    padding: var(--spacing-m) 0 var(--spacing-m);
    text-align: left;

    .blue-button,
    .blue-button:visited {
      background-color: #173945;
      border-radius: 2px;
      border: solid 1px #4e97b2;
      color: #fff;
      font-size: 14px;
      max-width: fit-content;
      padding: 10px 20px;
      text-decoration: none;
      text-align: center;
    }

    .blue-button:hover,
    .blue-button:focus,
    .blue-button:focus-visible {
      border: solid 1px #4e97b2;
      background-color: #316273;
    }
  }

  @media screen and (min-width: 1024px) {
    align-items: center;
    height: 34.25rem;
    display: flex;
    padding: 0 48px;
    width: 100%;

    img {
      max-width: 484px;
      width: 33%;
    }

    &.reverse {
      flex-direction: row-reverse;

      .text {
        padding: var(--spacing-m) var(--spacing-xl) var(--spacing-m) 0;
        text-align: right;
      }
    }

    .text {
      text-align: left;
      padding: var(--spacing-m) 0 var(--spacing-m) var(--spacing-xl);
    }
  }
}

</style>
